import React from 'react';
import FooterBar from "../components/FooterBar/FooterBar";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer-container">
      <FooterBar />
    </div>
  );
}
